import React, { useMemo } from 'react';
import { createEditor } from 'slate';
import { Editable, Slate, withReact } from 'slate-react';
import styled from 'styled-components';

import { Element, Leaf } from './Elements';
import type { CustomElement } from './types';
import { parseSlateValue } from './utils';

interface RichTextViewerProps {
  content: string | CustomElement[];
  className?: string;
}

const ViewerContainer = styled.div`
  font-size: 0.9375rem;
  line-height: 1.7;
  color: #374151;

  p {
    margin: 0;
  }

  p + p {
    margin-top: 8px;
  }
`;

const RichTextViewer: React.FC<RichTextViewerProps> = ({ content, className }) => {
  // Create a read-only editor
  const editor = useMemo(() => withReact(createEditor()), []);

  // Parse content to Slate value
  const value = useMemo(() => {
    if (typeof content === 'string') {
      return parseSlateValue(content);
    }
    return content;
  }, [content]);

  return (
    <Slate editor={editor} initialValue={value} onChange={() => {}}>
      <ViewerContainer className={className}>
        <Editable
          readOnly
          renderElement={(props) => <Element {...props} />}
          renderLeaf={(props) => <Leaf {...props} />}
        />
      </ViewerContainer>
    </Slate>
  );
};

export default RichTextViewer;
